//imports
import { all } from 'redux-saga/effects';

//Views
import deviceOverviewSagas from 'Modules/reports/views/overview/redux/saga';
import reportExportHistorySaga from 'Modules/reports/.components/reportExportHistory/redux/saga';

//merge sagas
export default function* rootSaga() {
	yield all([
		deviceOverviewSagas(),
		reportExportHistorySaga()
	]);
}
